/* eslint-disable import/prefer-default-export */
export const COURSES_LIST = `
 query($type: String) {
  courses(type: $type) {
    endLearnBookId
    lastTimeLearnedBook {
      id
      name
      isExpire
      type
      describe
      course
      code
      courseType
      projectCode
    }
    courseInfo {
      courseName
      icon
      subject {
        name
        bookList {
          id
          name
          isExpire
          code
          describe
          type
          courseType
          projectCode
        }
      }
    }
  }
}`;

export const COURSE_DATA = `
query ($courseId: Int, $id: Int, $type: String, $action: String, $chapterId: Int, $sectionId: Int) {
  courseData(courseId: $courseId, id: $id, type: $type, action: $action, chapterId: $chapterId, sectionId: $sectionId) {
    id
    type
    status
    title
    navigation
    subtitle
    description
    isBacktrack
    quizzes {
      id
      code
      title
      image
      explain
      ... on CourseQuizZsd {
        text
        wrongAnswer
      }
      ... on CourseQuizDx {
        options
        answer
        answerIndex
        question
        wrongAnswer
      }
    }
    answeredList {
      id
      answer
    }
  }
}`;

export const COURSE_CHAPTERS = `
query($courseId: Int!) {
  courseChapters(courseId: $courseId) {
    id,
    name,
    isActive,
    courseId,
    isAvailable,
    isExperience
  }
}`;

export const COURSE_SECTIONS = `
query($courseId: Int!, $chapterId: Int!) {
  courseSections(courseId: $courseId, chapterId: $chapterId) {
    sectionCount,
    isExistsVideo
    learnCount,
    score,
    isCompleted,
    sections {
      id,
      name,
      isActive,
      isAvailable,
      isHasKnowledge,
      courseId,
      chapterId,
      progress,
      videos {
        name,
        video,
        poster,
        videoDone,
        quizzes {
          question,
          options,
          answer,
          type,
          time,
        },
      },
    },
  }
}`;

export const COURSE_PROGRESS = `query($courseId: Int!) {
  courseProgress(courseId: $courseId) {
    learning,
    wrong,
    exam,
    chapter,
  }
}`;

export const WRONG_RECORDS = `query($courseId: Int) {
  lastDaysWrongRecords(courseId: $courseId) {
    label,
    value,
  }
}`;

export const EXAMSCORE = `query($courseId: Int) {
  lastDaysExamRecords(courseId: $courseId) {
    name,
    score,
    updatedAt,
    spendTime,
  }
}`;


export const COURSE_EXAM_RECORDS = `query($courseId: Int, $sectionId: Int, $page: Int, $size: Int, $type: String, $name: String) {
  courseExamRecords(courseId: $courseId, sectionId: $sectionId, page: $page, size: $size, type: $type, name: $name) {
    total,
    list {
      id,
      name,
      spendTime,
      updatedAt,
      score,
    }
  }
}`;

export const LEARING_VIDEO = `query($chapterId: Int!) {
  learningVideo(chapterId: $chapterId) {
    isPush
    video
    poster
    videoDone
    quizzes {
      question
      options
      answer
      type
      time
    }
  }
}`;

export const COURSE_RESULT = `
mutation ($id: Int!, $seconds: Int!, $courseId: Int, $type: String! $quizzes: String!, $isBacktrack: Int) {
  courseResult(id: $id, seconds: $seconds, courseId: $courseId, type: $type, quizzes: $quizzes, isBacktrack: $isBacktrack) {
    score
  }
}`;

export const READ_BOOK = `
mutation ($bookId: Int!) {
  readBook(bookId: $bookId)
}`;
